export const buildQueryString = (params) => {
  const query = new URLSearchParams();

  // Set query string
  // Params should be in format { name: "some name" }
  if (params.name) query.set("name", params.name);
  if (params.email) query.set("email", params.email);
  if (params.q) query.set("q", params.q);
  if (params.alt) query.set("alt", params.alt);

  // Params should be in format { label: "uuid" } or { status: "TODO" }
  if (params.label) query.set("label", params.label);
  if (params.teams) query.set("teams", params.teams);
  if (params.team) query.set("team", params.team);
  if (params.role) query.set("role", params.role);
  if (params.company_status) query.set("company_status", params.company_status);
  if (params.type) query.set("type", params.type);
  if (params.service_type) query.set("service_type", params.service_type);
  if (params.assigned_operator) query.set("assigned_operator", params.assigned_operator);
  if (params.assigned_role) query.set("assigned_role", params.assigned_role);
  if (params.status) query.set("status", params.status);
  if (params.is_active) query.set("is_active", params.is_active);
  if (params.due_date) query.set("due_date", params.due_date);
  if (params.start_date) query.set("start_date", params.start_date);

  if (params.created_from) query.set("created_from", params.created_from);
  if (params.created_until) query.set("created_until", params.created_until);
  if (params.ordering) query.set("ordering", params.ordering);

  // Payment filters
  if (params.payment_type !== undefined && params.payment_type !== "") query.set("payment_type", params.payment_type);
  if (params.payment_method !== undefined && params.payment_method !== "") query.set("payment_method", params.payment_method);

  return query.toString();
};
